import { ajax } from "rxjs/ajax";
import { Observable } from "rxjs";
import { getAuthAndDefaultHeaders } from "./apiConsts";
import { PlanListSuccessResponse } from "./api-response/PlanListSuccessResponse";
import { map } from "rxjs/operators";

export class ApiPlan {
  constructor(private apiEndpoint: string) {}

  listByOrganization(
    token: string,
    organization: string
  ): Observable<PlanListSuccessResponse> {
    return ajax({
      method: "GET",
      url: `${this.apiEndpoint}/organizations/${organization}/plans`,
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(map((x: any) => x.response));
  }
}
